module.exports = __webpack_public_path__ + "static/media/usuario_trabajador.c364965f.svg";